import clsx from 'clsx';
import React from 'react';
import { useLocation } from 'react-router-dom';

export interface NavItemButtonProps {
  path: string | string[];
  isActive?: boolean;
}

export const NavItemButton = ({ path, isActive = false, children }: React.PropsWithChildren<NavItemButtonProps>) => {
  const location = useLocation();
  const selected = Array.isArray(path) ? path.includes(location.pathname) : path === location.pathname;

  return (
    <div className='h-full' data-testid='nav-dropdown-button'>
      <div
        role='button'
        className={clsx(
          'hover:no-underline hover:bg-secondary-50',
          (!isActive || !selected) && 'hover:text-secondary-500',
          'flex transition-colors duration-300 font-normal h-full text-center leading-5',
          'py-4 px-6 block justify-center items-center rounded-md text-gray-60',
          selected && 'font-semibold text-neutral-900',
          isActive && 'text-neutral-900 bg-secondary-50'
        )}
      >
        {children}
      </div>
      {selected && <div className='w-full h-1 bg-secondary-500' style={{ position: 'relative', bottom: '4px' }} />}
    </div>
  );
};
